import { datetimeCovertertolocal } from '../datetime-converter';
import { AIS_NAME_FILTER, AIS_NAME_FILTER_ERROR, AIS_NAME_FILTER_SUCCESS,ADD_COORDINATE_DETAILS, ADD_COORDINATE_DETAILS_ERROR, ADD_COORDINATE_DETAILS_SUCCESS, ASN_DATA_LIST, ASN_DATA_LIST_ERROR, ASN_DATA_LIST_SUCCESS, COORDINATE_DETAILS, COORDINATE_DETAILS_ERROR, COORDINATE_DETAILS_SUCCESS, COORDINATE_LIST, COORDINATE_LIST_ERROR, COORDINATE_LIST_SUCCESS, DELETE_COORDINATE, DELETE_COORDINATE_ERROR, DELETE_COORDINATE_SUCCESS, DETECTION_ALGORITHM_LIST, DETECTION_ALGORITHM_LIST_ERROR, DETECTION_ALGORITHM_LIST_SUCCESS, MULTIPLEMODEL_LIST, MULTIPLEMODEL_LIST_ERROR, MULTIPLEMODEL_LIST_SUCCESS, REALTIME_DETECTION_DATA, REALTIME_DETECTION_DATA_ERROR, REALTIME_DETECTION_DATA_SUCCESS, REALTIME_DETECTION_LIST, REALTIME_DETECTION_LIST_ERROR, REALTIME_DETECTION_LIST_SUCCESS, REALTIME_DETECTON_ALARM_DATA, REALTIME_DETECTON_ALARM_ERROR, REALTIME_DETECTON_ALARM_SUCCESS, UPDATE_COORDINATE, UPDATE_COORDINATE_ERROR, UPDATE_COORDINATE_SUCCESS, UPDATE_REALTIME_DETECTION_LIST, UPDATE_REALTIME_DETECTION_LIST_DETAILS, UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR, UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS, UPDATE_REALTIME_DETECTION_LIST_ERROR, UPDATE_REALTIME_DETECTION_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS, MODAL_DATA_LIST_ERROR, MODAL_DATA_LIST_SUCCESS, MODAL_DATA_LIST, } from './constants';

export default function inspectiondata(state, action) {

	let multimod = [];
	let asndata = [];
	let coordinates = [];
	let pagination = {};

	switch (action.type) {
	case REALTIME_DETECTION_LIST:
		return { ...state, pending: true };
	case REALTIME_DETECTION_LIST_SUCCESS:
		return { ...state, realtimedetection_data: action.payload.data, pending: false, pagination: pagination  };
	case REALTIME_DETECTION_LIST_ERROR:
		return { ...state, realtimedetection_data:action.payload,error: true, pending: false };

	case UPDATE_REALTIME_DETECTION_LIST:
		return { ...state, pending: true };

	case UPDATE_REALTIME_DETECTION_LIST_SUCCESS:
		return { ...state, pending: false };

	case UPDATE_REALTIME_DETECTION_LIST_ERROR:
		return { ...state,  error: true, pending: false };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	case REALTIME_DETECTION_DATA:
		return { ...state, pending: true };
	case REALTIME_DETECTION_DATA_SUCCESS:
		return { ...state, patch_data: action.payload,  };
	case REALTIME_DETECTION_DATA_ERROR:
		return { ...state, error: true,  };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS:
		return { ...state, pending: true };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details: action.payload, error: false };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case REALTIME_DETECTON_ALARM_DATA:
		return { ...state, pending: true };
	case REALTIME_DETECTON_ALARM_SUCCESS:
		return { ...state, inspection_alarm: action.payload,  };
	case REALTIME_DETECTON_ALARM_ERROR:
		return { ...state, error: true,  };
	case MULTIPLEMODEL_LIST:
		return { ...state, pending: true };
			
	case MULTIPLEMODEL_LIST_SUCCESS:
				
		if (action.payload && action?.payload?.data?.length > 0) {
					
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.name = item && item?.name && item?.name ? item.name : '';

				return multimod.push(data);
			});
				
			return { ...state, multimod: multimod, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, multimod: [], error: false };
			} else {
				return { ...state,  error: true };
			}
		}
 
	case MULTIPLEMODEL_LIST_ERROR:
		return { ...state, error: true };

	case ASN_DATA_LIST:
		return { ...state, pending: true };

	case ASN_DATA_LIST_SUCCESS:

		if (action.payload && action?.payload?.data?.length > 0) {

			action?.payload?.data?.map((item) => {
				let data = {};
				data.datetime = item.datetime ? item.datetime : null ;
				data.latitude = item && item?.latitude ? item.latitude : [];
				data.longitude = item && item?.longitude ? item.longitude : [];
				data.name = item && item?.name ? item.name : 'No Data';
				data.speed = item && item?.speed ? item.speed : [];

				return asndata.push(data);
			});

			return { ...state, asndata: asndata, error: false };

		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, asndata: [], error: false };
			} else {
				return { ...state, error: true };
			}
		}

	case ASN_DATA_LIST_ERROR:
		return { ...state, error: true };


	// ------------------------------------------------------------
	// Detection Info modal.
	//
	// `modalPending` is separate from `pending` on purpose: `pending` drives
	// the page's full-screen <Spin />, while the modal shows its own antd
	// Spin from `modalPending`.
	// ------------------------------------------------------------
	case MODAL_DATA_LIST:
		// Clear the previous record so stale data never flashes while loading.
		return { ...state, modaldata: null, modalPending: true };

	case MODAL_DATA_LIST_SUCCESS: {

		// action.payload          -> the single realtime detection record from the API
		// action.trajectoryBoolean -> truthy: correctedDetectionResults
		//                             falsy : detectionResults
		const record = action.payload;

		if (record && typeof record === 'object' && !Array.isArray(record)) {

			const item = (action.trajectoryBoolean
				? record?.correctedDetectionResults
				: record?.detectionResults) || {};

			const dateTime = datetimeCovertertolocal(
				item?.cpaSourceDatetime
					? item.cpaSourceDatetime
					: null
			);

			const modaldata = {
				// ---- Single values ----

				cpaSourceDatetime: item?.cpaSourceDatetime
					? `${dateTime.localdate} ${dateTime.localtime}`
					: null,

				cpaSourceDistance:
					item?.cpaSourceDistance !== undefined &&
					item?.cpaSourceDistance !== null ? item.cpaSourceDistance : null,

				distanceRange:
					record?.distanceRange !== undefined &&
					record?.distanceRange !== null ? record.distanceRange : [],

				depthRange:
					record?.depthRange !== undefined &&
					record?.depthRange !== null ? record.depthRange : [],

				// ---- Array values(Multiple Values) ----

				ber: Array.isArray(item?.ber)
					? item.ber
					: [],

				pmr: Array.isArray(item?.pmr)
					? item.pmr
					: [],

				dominantBand: Array.isArray(item?.dominantBand)
					? item.dominantBand
					: [],

				peakFrequency_Hz: Array.isArray(item?.peakFrequency_Hz)
					? item.peakFrequency_Hz
					: [],

				spectralFlatness: Array.isArray(item?.spectralFlatness)
					? item.spectralFlatness
					: [],

				starboardLatitude: Array.isArray(item?.starboardLatitude)
					? item.starboardLatitude
					: [],

				starboardLongitude: Array.isArray(item?.starboardLongitude)
					? item.starboardLongitude
					: [],

				eventPositions: Array.isArray(item?.eventPositions)
					? item.eventPositions
					: [],

				sourceDistances: Array.isArray(item?.sourceDistances)
					? item.sourceDistances
					: [],

				sourceSpeedKts: Array.isArray(item?.sourceSpeedKts)
					? item.sourceSpeedKts
					: [],

				sourceSpeedms: Array.isArray(item?.sourceSpeedms)
					? item.sourceSpeedms
					: [],

				timeStart: Array.isArray(item?.timeStart)
					? item.timeStart
					: [],

				// Array of objects: [{ 309: [..], 319: [..] }, { ... }]
				// ChannelFrequencies_Hz[i] belongs to peakFrequency_Hz[i].
				ChannelFrequencies_Hz: Array.isArray(item?.ChannelFrequencies_Hz)
					? item.ChannelFrequencies_Hz
					: [],
			};

			return { ...state, modaldata: modaldata, modalPending: false, error: false };

		} else {
			// Empty / unexpected response -> modal shows <Empty />.
			return { ...state, modaldata: null, modalPending: false, error: true };
		}
	}

	case MODAL_DATA_LIST_ERROR:
		return { ...state, modaldata: null, modalPending: false, error: true };



	case DETECTION_ALGORITHM_LIST:
		return {...state, loading : false , error : false};
	case DETECTION_ALGORITHM_LIST_SUCCESS:
		return { ...state, detectionalgorithm:action.payload ,  loading: false, error: false };
	case DETECTION_ALGORITHM_LIST_ERROR:
		return {...state, loading : false , error : true};

	case COORDINATE_LIST:
		return { ...state, };

	case COORDINATE_LIST_SUCCESS:

		if (action.payload && action.payload.length > 0) {
			action.payload.map((item) => {

				let data = {};
				let startTime = datetimeCovertertolocal(item.createdAt ? item.createdAt : '');
				let newStartTime = `${startTime.localdate} ${startTime.localtime}`;

				data.id = item.id ? item.id : 0;
				data.channelinfoId = item.channelinfo.name ? item.channelinfo.name : 'No Data';
				data.pidsinfoId = item.pidsinfo.name ? item.pidsinfo.name : 'No Data';
				data.name = item.name ? item.name : '';
				data.latitude = item.latitude ? item.latitude : '';
				data.longitude = item.longitude ? item.longitude : '';
				data.distance = item.nearestPipelineCoordinate.distance ? item.nearestPipelineCoordinate.distance : 'No Data';
				data.ODMeter = item.nearestPipelineCoordinate?.ODMeter !== null ? item.nearestPipelineCoordinate.ODMeter : 'No Data';
				data.fibrelatitude = item.nearestPipelineCoordinate.latitude ? item.nearestPipelineCoordinate.latitude : 'No Data';
				data.fibrelongitude = item.nearestPipelineCoordinate.longitude ? item.nearestPipelineCoordinate.longitude : 'No Data';
				data.createdAt = item.createdAt ? newStartTime : '';

				return coordinates.push(data);
			});

			return {
				...state,
				coordinates: coordinates,
				
				error: false
			};
		} else {
			if (action.payload && action.payload.length === 0) {
				return {
					...state,
					coordinates: coordinates,
					
					error: false
				};
			} else {
				return {
					...state,
					
					error: true
				};
			}
		}

	case COORDINATE_LIST_ERROR:
		return { ...state,  error: true };

	case COORDINATE_DETAILS:
		return { ...state, pending: true };

	case COORDINATE_DETAILS_SUCCESS:
		return {
			...state,
			details: action.payload,
			
			error: false
		};

	case COORDINATE_DETAILS_ERROR:
		return { ...state,  error: true };

	case ADD_COORDINATE_DETAILS:
		return { ...state, pending: false };

	case ADD_COORDINATE_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_COORDINATE_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_COORDINATE:
		return { ...state, pending: false };

	case UPDATE_COORDINATE_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_COORDINATE_ERROR:
		return { ...state, pending: false, error: true };

	case DELETE_COORDINATE:
		return { ...state, pending: false };

	case DELETE_COORDINATE_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_COORDINATE_ERROR:
		return { ...state, pending: false, error: true };

	case AIS_NAME_FILTER:
		return { ...state, pending: true };

	case AIS_NAME_FILTER_SUCCESS:
		return { ...state, ais_name: action.payload, pending: false };

	case AIS_NAME_FILTER_ERROR:
		return { ...state, ais_name: action.payload, error: true, pending: false };

	default: {
		throw Error('Unknown action: ' + action.type);
	}}
}